import { render, staticRenderFns } from "./menuAccess.vue?vue&type=template&id=50a7f3e8&scoped=true"
import script from "./menuAccess.vue?vue&type=script&lang=js"
export * from "./menuAccess.vue?vue&type=script&lang=js"
import style0 from "./menuAccess.vue?vue&type=style&index=0&id=50a7f3e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7f3e8",
  null
  
)

export default component.exports